import { Group, NumberInput, Tooltip } from '@mantine/core';
import { IconArrowRight, IconTrash } from '@tabler/icons-react';
import { ChastiaConfigForm, TechnicianPairing } from 'components/forms/remote-source/config/types';
import { UserSelect } from 'components/selects/UserSelect';
import { useCallback } from 'react';
import { useConfirm } from 'components/modals/message/MessageProvider';
import ActionIcon from 'components/ActionIcon';

interface TechnicianPairingRowProps {
  form: ChastiaConfigForm;
  item: TechnicianPairing;
  index: number;
}

/**
 * A single row for Technician Pairing configuration.
 */
export default function TechnicianPairingRow({ form, item, index }: TechnicianPairingRowProps) {
  const { confirm } = useConfirm();

  const removeRow = useCallback(() => {
    if (!item.chastiaId && !item.userId) {
      form.removeListItem('technicians', index);
    } else {
      confirm({
        title: 'Odstrániť riadok?',
        content: 'Naozaj chcete odstrániť tento riadok mapovania technikov?',
        onConfirm: () => form.removeListItem('technicians', index),
      });
    }
  }, [confirm, form, item, index]);

  return (
    <Group key={item.key} className="grid max-w-[972px] grid-cols-[1fr_24px_1fr_44px] items-center gap-y-0">
      <NumberInput size="md" placeholder="ID Chastia" {...form.getInputProps(`technicians.${index}.chastiaId`)} />
      <IconArrowRight stroke={1.5} />
      <UserSelect
        size="md"
        placeholder="Vybrať používateľa"
        hasPermissionAnywhere="fill-out-revisions"
        showDiscarded={false}
        {...form.getInputProps(`technicians.${index}.userId`)}
      />
      <Group spacing={8} noWrap>
        <Tooltip label="Odstrániť riadok" openDelay={500} withArrow={false}>
          <ActionIcon variant="subtle" size="md" onClick={removeRow}>
            <IconTrash />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Group>
  );
}
